import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["imageDir", "audioDir", "scanButton", "scanStatus", "preview"]

  scan() {
    const imageDir = this.imageDirTarget.value.trim()
    const audioDir = this.audioDirTarget.value.trim()

    if (!imageDir && !audioDir) {
      alert("Please enter at least one folder path.")
      return
    }

    this.scanButtonTarget.disabled = true
    this.scanStatusTarget.classList.remove("hidden")
    this.scanStatusTarget.textContent = "Scanning..."

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    formData.append("image_dir", imageDir)
    formData.append("audio_dir", audioDir)

    fetch(this.scanUrl, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error("Scan failed")
        return response.text()
      })
      .then(html => {
        Turbo.renderStreamMessage(html)
        this.scanStatusTarget.textContent = "Scan complete"
        this.scanStatusTarget.classList.remove("hidden")
      })
      .catch(error => {
        this.scanStatusTarget.textContent = `Error: ${error.message}`
        this.scanStatusTarget.classList.remove("hidden")
      })
      .finally(() => {
        this.scanButtonTarget.disabled = false
      })
  }

  get scanUrl() {
    return "/slideshow_configs/scan_media"
  }
}
